import styled from "styled-components";
import useTuitionManage from "features/teacher/hooks/student/useTuitionManage";
import TuitionModal from "./TuitionModal";
import Modal from "shared/components/Modal";
import PayDateModal from "./PayDateMoal";
import { hw, scrollbar } from "features/homework/homeworkUi";

interface TdProps {
    isAmount?: boolean;
}

interface SmallButtonProps {
    isPaid?: boolean;
}

interface ThProps {
    onClick?: () => void;
    isSorted?: boolean;
    sortDirection?: 'asc' | 'desc';
}

const TuitionManage = () => {
    const { searchedTuitionList, onPayButtonClick, onChangeDate, showTuitionModal, tuitionInput, onChange, onCancelClick, onPayClick, date, onChangeNonpay, onChangeSearch, search, nonpay,
        isOpenSucceedModal, setIsOpenSucceedModal, isOpenNullModal, setIsOpenNullModal, payDate, isOpenPayDateModal, onChangePayDate, onPayDateClickHandler, onPayDateModalCancelHandler, onPayDateModalConfirmClickHandler, isOpenPayDateSucceedModal, onPayDateSucceedModalConfirmClickHandler,
        sortConfig, onSort
    } = useTuitionManage();

    const getTuitonList = () => {
        const rows = searchedTuitionList.map((value) => {
            if(nonpay && (!value.approver || value.unpaied <= 0)) {
                return null;
            }

            return (
                <Tr key={value.uid}>
                    <Td>{value.name}</Td>
                    <Td>{value.lesson}</Td>
                    <TdTel>{value.tel}</TdTel>
                    <Td>{value.paied_date}</Td>
                    <Td isAmount>{value.unpaied.toLocaleString()}</Td>
                    <Td isAmount>{parseInt(value.fee).toLocaleString()}</Td>
                    <Td>{value.method}</Td>
                    <Td>{value.etc}</Td>
                    <Td>{value.approver}</Td>
                    <Td>
                        <SmallButton 
                            isPaid={!!value.approver}
                            onClick={() => onPayButtonClick(value.uid)}
                        >
                            {value.approver ? "납부됨" : "납부"}
                        </SmallButton>
                    </Td>
                </Tr>
            );
        }).filter(Boolean);

        if (!rows.length) {
            return (
                <Tr>
                    <EmptyTd colSpan={10}>
                        {nonpay ? "미납 원생이 없습니다." : search ? "검색 결과가 없습니다." : "이번 달 납부 내역이 없습니다."}
                    </EmptyTd>
                </Tr>
            );
        }

        return rows;
    }

    return(
        <Container>
            <PayDateModal isOpen={isOpenPayDateModal} onChange={onChangePayDate} onCancelClick={onPayDateModalCancelHandler} onConfirmClick={onPayDateModalConfirmClickHandler} date={payDate}/>
            <Modal isOpen={isOpenNullModal} onClose={() => setIsOpenNullModal(false)} title="ERROR" content="납부 금액을 입력해 주세요"/>
            <Modal isOpen={isOpenPayDateSucceedModal} onClose={onPayDateSucceedModalConfirmClickHandler} title="SUCCESS" content="납부일이 변경 되었습니다"/>
            <Modal isOpen={isOpenSucceedModal} onClose={() => setIsOpenSucceedModal(false)} title="SUCCESS" content="납부 승인 되었습니다"/>
            {showTuitionModal ? <TuitionModal input={tuitionInput} onChange={onChange} onCancelClick={onCancelClick} onPayClick={onPayClick}/> : null}
            <Head>
                <div>
                    <Title>수강료 납부</Title>
                    <Sub>이번 달 납부 현황을 확인하고 승인합니다.</Sub>
                </div>
            </Head>
            <Wrapper>
                <Toolbar>
                    <SearchInput 
                        type="text" 
                        placeholder="원생 검색" 
                        value={search} 
                        onChange={onChangeSearch}
                    />
                    <DateWrap>
                        <Label>조회</Label>
                        <DateInput 
                            type="number" 
                            name="year" 
                            value={date.year} 
                            onChange={onChangeDate}
                            min="2000"
                            max="2100"
                        />
                        <Unit>년</Unit>
                        <DateInput 
                            type="number" 
                            name="month" 
                            value={date.month} 
                            onChange={onChangeDate}
                            min="1"
                            max="12"
                        />
                        <Unit>월</Unit>
                    </DateWrap>
                    <NonPayWrap>
                        <CheckNonPay 
                            type="checkbox" 
                            id="nonpay" 
                            checked={nonpay}
                            onChange={onChangeNonpay}
                        />
                        <Label htmlFor="nonpay">미납자만</Label>
                    </NonPayWrap>
                    <FixedPayDateWrap>
                        <Label>결제일</Label>
                        <FixedPayDate>{`매월 ${payDate}일`}</FixedPayDate>
                    </FixedPayDateWrap>
                    <PayDateButton type="button" onClick={onPayDateClickHandler}>결제일 설정</PayDateButton>
                </Toolbar>
                <Table>
                    <thead>
                        <Tr>
                            <Th 
                                onClick={() => onSort('name')}
                                isSorted={sortConfig.key === 'name'}
                                sortDirection={sortConfig.key === 'name' ? sortConfig.direction : undefined}
                            >
                                학생 {sortConfig.key === 'name' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                            </Th>
                            <Th>학급</Th>
                            <ThTel>전화</ThTel>
                            <Th>결제일</Th>
                            <Th>미납</Th>
                            <Th>수강료</Th>
                            <Th>방식</Th>
                            <Th>비고</Th>
                            <Th>승인자</Th>
                            <Th>관리</Th>
                        </Tr>
                    </thead>
                    <Tbody>
                        {getTuitonList()}
                    </Tbody>
                </Table>
            </Wrapper>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 18px 18px 14px;
    border-radius: 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    box-shadow: ${hw.shadow};
    min-width: 0;
    min-height: 0;
    height: 100%;
    overflow: hidden;
`

const Head = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    flex-shrink: 0;
`

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`

const Sub = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${hw.textMuted};
`

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 12px;
    min-width: 0;
    flex: 1;
    min-height: 0;
`

const Toolbar = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px 12px;
    background: ${hw.bg};
    border: 1px solid ${hw.border};
    border-radius: 12px;
    flex-shrink: 0;
`

const SearchInput = styled.input`
    width: 140px;
    padding: 8px 12px;
    border: 1px solid ${hw.border};
    border-radius: 8px;
    font-size: 13px;
    color: ${hw.text};
    background: ${hw.surface};

    &:focus {
        outline: none;
        border-color: ${hw.brand};
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }

    &::placeholder {
        color: ${hw.textSubtle};
    }
`

const DateWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    background: ${hw.surface};
    padding: 6px 10px;
    border-radius: 8px;
    border: 1px solid ${hw.border};
`

const DateInput = styled.input`
    width: 56px;
    padding: 6px 4px;
    border: 1px solid ${hw.border};
    border-radius: 6px;
    font-size: 13px;
    text-align: center;
    color: ${hw.text};

    &:focus {
        outline: none;
        border-color: ${hw.brand};
        box-shadow: 0 0 0 3px rgba(223, 0, 0, 0.12);
    }

    &::-webkit-inner-spin-button,
    &::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
`

const Unit = styled.span`
    color: ${hw.textMuted};
    font-size: 13px;
`

const Label = styled.label`
    color: ${hw.textMuted};
    font-size: 12px;
    font-weight: 600;
`

const NonPayWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: ${hw.surface};
    border-radius: 8px;
    border: 1px solid ${hw.border};
`

const CheckNonPay = styled.input`
    width: 16px;
    height: 16px;
    margin: 0;
    cursor: pointer;
    accent-color: ${hw.brand};
`

const FixedPayDateWrap = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 10px;
    background: ${hw.brandSoft};
    border-radius: 8px;
    border: 1px solid ${hw.brandMuted};
`

const FixedPayDate = styled.span`
    color: ${hw.brand};
    font-size: 12px;
    font-weight: 700;
`

const PayDateButton = styled.button`
    appearance: none;
    margin-left: auto;
    background: ${hw.brand};
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;

    &:hover {
        background: ${hw.brandDark};
    }
`

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
`

const Tbody = styled.tbody`
    display: block;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    width: 100%;
    ${scrollbar}
`

const Tr = styled.tr`
    display: table;
    width: 100%;
    table-layout: fixed;
    
    &:nth-child(even) {
        background-color: #FCFCFD;
    }
    
    &:hover {
        background-color: ${hw.brandSoft};
    }

    thead & {
        background-color: #FAFBFC;
        
        th {
            font-weight: 700;
            color: ${hw.textMuted};
            padding: 12px 8px;
            border-bottom: 1px solid ${hw.border};
        }
    }
`

const Td = styled.td<TdProps>`
    padding: 10px 8px;
    color: ${hw.text};
    text-align: ${props => props.isAmount ? 'right' : 'center'};
    font-size: 12px;
    font-weight: 500;
    border-bottom: 1px solid ${hw.border};
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${props => props.isAmount && `
        font-variant-numeric: tabular-nums;
        color: ${props.children === '0' ? hw.textSubtle : hw.text};
    `}
`

const EmptyTd = styled.td`
    padding: 48px 12px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
    border-bottom: none;
`

const TdTel = styled(Td)`
    width: 110px;
`

const SmallButton = styled.button<SmallButtonProps>`
    border-radius: 6px;
    border: 1px solid ${props => props.isPaid ? hw.brandMuted : hw.brand};
    width: 58px;
    background: ${props => props.isPaid ? hw.brandSoft : hw.brand};
    color: ${props => props.isPaid ? hw.brand : '#FFFFFF'};
    font-size: 12px;
    font-weight: 600;
    padding: 6px 8px;
    cursor: pointer;

    &:hover {
        background: ${props => props.isPaid ? hw.brandMuted : hw.brandDark};
    }
`

const Th = styled.th<ThProps>`
    padding: 12px 8px;
    color: ${hw.textMuted};
    font-weight: 700;
    font-size: 12px;
    text-align: center;
    border-bottom: 1px solid ${hw.border};
    background-color: #FAFBFC;
    cursor: ${props => props.onClick ? 'pointer' : 'default'};
    position: sticky;
    top: 0;
    z-index: 1;
    white-space: nowrap;

    &:hover {
        background-color: ${props => props.onClick ? hw.brandSoft : '#FAFBFC'};
    }

    ${props => props.isSorted && `
        color: ${hw.brand};
        background-color: ${hw.brandSoft};
    `}
`

const ThTel = styled(Th)`
    width: 110px;
`

export default TuitionManage;
